import smallLogo from '../assets/images/brands/odrg/logo-small.png'
import { BrandingConfig } from './branding'

const brandingOdrg: BrandingConfig = {
  company: {
    name: 'ODRG Next Octave',
    website: 'https://odrg.com',
    supportEmail: 'info@odrg.com',
  },
  assets: {
    logoSmall: smallLogo,
    logoLarge: undefined,
  },
  theme: {
    colors: {
      // Magenta from their website
      primary: '#C6007E',
      primaryLight: 'rgba(198, 0, 126, 0.5)',
      // Purple accent color
      secondary: '#6B1B9A',
      // Dark navy background
      background: '#0A0F2C',
      // Slightly lighter card background
      cardBackground: '#141B3D',
      // White text
      text: '#ffffff',
      textLight: 'rgba(255, 255, 255, 0.8)',
    },
  },
}

export default brandingOdrg
